import React from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';

import SourceLink from 'components/SourceLink';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          Mass Housing Assasment,  on Bumigora Hackathon @2018
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
